import styled from 'styled-components';
import { s } from './NPL.styles';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedLoanPrincipalProps {
  expectedLoanPrincipal: ReturnType<NplCalculation['getExpectedLoan']>;
}

const ExpectedLoanPrincipal = (props: IExpectedLoanPrincipalProps) => {
  const { expectedLoanPrincipal } = props;
  return (
    <s.Div>
      <s.Title>예상 대출원리금</s.Title>
      <div>
        <Table>
          <s.DivRow position="top">
            <s.LeftCell>근저당권 설정액</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedLoanPrincipal.row1_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>(예상) 대출원금</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedLoanPrincipal.row2_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF">
            <s.LeftCell>(예상) 대출잔액+미수이자</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedLoanPrincipal.row3_1)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>연체이자율</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedLoanPrincipal.row1_2, true, true)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow>
            <s.LeftCell>(경매기간) 연체이자 기간수</s.LeftCell>
            <s.RightCell>{expectedLoanPrincipal.row2_2}</s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF">
            <s.LeftCell>(경매기간) 연체이자 금액</s.LeftCell>
            <s.RightCell>
              {ReportFormatNumber(expectedLoanPrincipal.row3_2)}
            </s.RightCell>
          </s.DivRow>
          <s.DivRow backgroundColor="#F2F7FF" position="bottom">
            <s.LeftCell style={{ color: '#222222' }}>합계금액</s.LeftCell>
            <s.RightCell style={{ color: '#008AFF', fontWeight: '700' }}>
              {ReportFormatNumber(expectedLoanPrincipal.row4)}
            </s.RightCell>
          </s.DivRow>
        </Table>
        <s.BlueSmallText>*선순위 내역은 상세분석이 요구됨</s.BlueSmallText>
      </div>
    </s.Div>
  );
};

export default ExpectedLoanPrincipal;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;
